<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Name</th>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <th scope="row">Created</th>
            <td>{{ item['created'] }}</td>
          </tr>
          <tr>
            <th scope="row">Message</th>
            <td>{{ item['message'] }}</td>
          </tr>
          <tr>
            <th scope="row">Audio</th>
            <td>
              <template v-if="item['audio'] != undefined">        
                <router-link                                
                  :to="{name: 'AudioShow', params: { id: item['audio']['@id'] }}">
                  {{ item['audio'].name }}
                </router-link>
              </template>
            </td>
          </tr>
          <tr>
            <th scope="row">Video</th>
             <td>
                <template v-if="item['video'] != undefined">     
                  <router-link                
                    :to="{name: 'VideoShow', params: { id: item['video']['@id'] }}">
                    {{ item['video'].name }}
                  </router-link>
                </template>
            </td>
          </tr>  
          <tr>
            <th scope="row">IsValid</th>
             <td>
                <div v-if="item['isValid']">
                  <i class="testimonial-icon-valid-true fas fa-check-circle"></i>
                </div>
                <div v-else>
                  <i class="testimonial-icon-valid-false fas fa-times-circle"></i>
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'TestimonialList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <router-link
      v-if="item"
      :to="{ name: 'TestimonialUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields('testimonial/del', {
      deleteError: 'error',
    }),
    ...mapFields('testimonial/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),
  },

  beforeDestroy () {
    this.reset();
  },

  created () {
    console.log(this.$route.params.id);    
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      del: 'testimonial/del/del',
      reset: 'testimonial/show/reset',
      retrieve: 'testimonial/show/retrieve',
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'TestimonialList' }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/testimonial/Show.vue